import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DocumentCategoryService} from "../../../../../service/repository/document-category.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {DocumentCategoryView} from "../../../../../domain/documentCategoryView";
import {DocumentService} from "../../../../../service/repository/document.service";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";

@Component({
    selector: 'sub-categories-list',
    templateUrl: './sub-categories-list.component.html',
    styleUrls: ['./sub-categories-list.component.scss'],
    providers: [ DocumentService ],
    animations:  [
        trigger('rotateIcon', [
            state("hide", style({ transform: 'rotate(-90deg)' })),
            state("show" , style({ transform: 'rotate(0deg)' })),
            transition('* => *', [
                animate('100ms')
            ])
        ])

    ]
})
export class SubCategoriesListComponent implements OnInit {

    @Input() categories : DocumentCategoryView[] = [];

    @Input() showHiddenFolders : boolean = false;

    constructor(private categoryService : DocumentCategoryService,private documentService: DocumentService) {
    }

    ngOnInit() {
    }

    public showSubCategories(c : DocumentCategoryView) : void {
        c.changeVisibility();
        this.categoryService.setCategorySelected(c);
    }

    public showCategory(c : DocumentCategoryView) : void {
        this.categoryService.setCategoryToShow(c);
    }


}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/repository/explorer/category-explorer/sub-categories-list/sub-categories-list.component.ts